import React from 'react';
import styled from 'styled-components'

import Spotify from '../images/spotify-podcast.svg';
import Apple from '../images/apple-podcast.svg';
// import Google from '../images/google-podcast.svg';

const SectionContainer = styled.section`
    z-index: 2;
    margin-top: -50px;
    position: relative;

    @media (min-width: 1150px) {
        padding: 50px 0;
        margin-top: -100px;
    }
`
const Icons = styled.div`
    display: flex;
    margin: 0 auto;
    max-width: 220px;
    flex-flow: column;
    justify-content: space-evenly;
    
    @media (min-width: 768px) {
        max-width: 600px;
        flex-flow: row;
    }

    a {
        width: 100%;
        padding: 10px 0;

        @media (min-width: 768px) {
            width: 32%;
        }
    }
`

const Title = styled.h2`
    padding: 0 50px;

    @media (min-width: 1150px) {
        max-width: 900px;
        margin: 20px auto;
    }
`
const Podcast = () => {
    return (
        <SectionContainer>
            <Title>Or get us direct from your source</Title>

            <Icons>
                <a
                    target="_blank" 
                    rel="noopener noreferrer"
                    href="https://open.spotify.com/show/0NxCuapxIxT3wbIJUqm0IO" 
                >
                    <img src={Spotify} alt="Spotify"/>
                </a>
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://podcasts.apple.com/gb/podcast/episode-1-what-is-a-dermatology-nurse/id1531940764"
                >
                    <img src={Apple} alt="Apple"/>
                </a>
            </Icons>
        </SectionContainer>
    );
};

export default Podcast;
